import { isWithinInterval, parseISO, parse, format, addMinutes } from 'date-fns';
import { TLocationsBlackout } from '@api/blackout/types';

export const formatTimeTo12Hour = (time: string): string => {
  const [hour, minute] = time.split(':').map(Number);

  const period = hour >= 12 ? 'PM' : 'AM';

  const formattedHour = (hour % 12 || 12).toString().padStart(2, '0');

  return `${formattedHour}:${minute.toString().padStart(2, '0')} ${period}`;
};

const addOneMinute = (time: string): string => {
  const parsedTime = parse(time, 'HH:mm', new Date());

  if (time === '23:59') {
    return format(parsedTime, 'HH:mm');
  }

  const updatedTime = addMinutes(parsedTime, 1);

  return format(updatedTime, 'HH:mm');
};

const formatDate = (dateValue: string) => {
  if (dateValue) {
    return format(parseISO(dateValue), 'MM/dd/yyyy');
  }
  return '';
};

const calculateDurationInMinutes = (
  startTime: string,
  endTime: string,
  isDateInInterval: boolean,
): number => {
  const [startHour, startMinute] = startTime.split(':').map(Number);

  const [endHour, endMinute] = endTime.split(':').map(Number);

  const startInMinutes = startHour * 60 + startMinute;

  const endInMinutes = endHour * 60 + endMinute + 1;

  return endInMinutes - startInMinutes;
};

export const getBlackourLocationForDate = (
  selectedDate: Date,
  locations: TLocationsBlackout[] | undefined,
) =>
  locations?.map((location) => {
    const startDate = parseISO(location.from);

    const endDate = parseISO(location.to);

    const isStartDay = selectedDate.toDateString() === startDate.toDateString();

    const isEndDay = selectedDate.toDateString() === endDate.toDateString();

    const isDateInInterval = isWithinInterval(selectedDate, {
      start: startDate,
      end: endDate,
    });

    if (!isDateInInterval && !isStartDay && !isEndDay) {
      return {
        startTime: '',
        duration: 0,
      };
    }

    const startTime = isStartDay ? location.from_time : '06:00';

    const endTime = isEndDay ? location.to_time : '23:59';

    const durationInMinutes = calculateDurationInMinutes(startTime, endTime, isDateInInterval);

    return {
      id: location.id,
      locationId: location.location_id,
      startTime: formatTimeTo12Hour(startTime),
      duration: durationInMinutes,
      from: formatDate(location.from),
      to: formatDate(location.to),
      from_time: formatTimeTo12Hour(location.from_time),
      to_time: formatTimeTo12Hour(addOneMinute(location.to_time)),
    };
  });
